/* eslint-disable react/react-in-jsx-scope */
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import {
  FORGETPASSWORD,
  LOGIN_PATH,
  PUBLIC_PATH,
  REGISTER_PATH,
  AFTERREGISTER,
  RESETPASSWORD,
  SSO_CALLBACK_PATH,
} from "../navigationPaths";
import WithoutAuth from "layouts/WithoutAuth";
import ConnexionPage from "pages/Connexion/ConnexionPage";
import InscriptionPage from "pages/Inscription/InscriptionPage";
//import ForgetPasswordPage from "pages/ForgetPasswordPage/ForgetPasswordPage";

import { Activation } from "components/ActivationForm/Activation";
import PageAfterRegister from "components/ActivationForm/pageAfterRegister";
import LandingPage from "pages/LandingPage/LandingPage";
import ResetPasswordConfirmPage from "pages/ResetPasswordConfirm/ResetPasswordConfirm";
import ErrorPasswordPage from "pages/ErrorPasswordPage/ErrorPasswordPage";
import EasySuiteCallback from "pages/SSO/EasySuiteCallback";

export const publicRoutes = [
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: SSO_CALLBACK_PATH,
    element: <EasySuiteCallback />,
  },
  {
    path: PUBLIC_PATH,
    errorElement: <ErrorBoundary />,
    element: <WithoutAuth />,
    children: [
      {
        path: "",
        element: <ConnexionPage />,
      },
      {
        path: REGISTER_PATH,
        element: <InscriptionPage />,
      },
      {
        path: LOGIN_PATH,
        element: <ConnexionPage />,
      },
      {
        path: RESETPASSWORD,
        element: <ResetPasswordConfirmPage />,
      },
      {
        path: FORGETPASSWORD,
        element: <ErrorPasswordPage />,
      },
      {
        path: "activate/:uid/:token",
        element: <Activation />,
      },
      {
        path: AFTERREGISTER,
        element: <PageAfterRegister />,
      },
    ],
  },
];
